import { ApiHelper } from 'utils/apiHelper';

import { BoundCurrentUserSelectors } from 'reactApp/modules/CurrentUserModule';
import { ToastNotify } from 'reactComponents/ToastNotify/ToastNotify';

const $ = require('jQuery');
const inherit = require('inherit');
const Emitter = require('Emitter');
const DialogManager = require('system/mediators/DialogManager');
const AutopaymentView = require('../blocks/billing-autopayment/billing-autopayment');
const AutopaymentDialogView = require('../blocks/billing-autopayment-dialog/billing-autopayment-dialog');

const _Autopayment = inherit(Emitter, {
    constructor: function Autopayment({ enabled, stretched } = {}) {
        Autopayment.parent.call(this);

        this._enabled = enabled;
        this._stretched = stretched;

        this.destroyed = false;
        this._mainView = null;
        this._onSubmit = this._onSubmit.bind(this);
    },

    renderTo(container) {
        const balanceModel = Autopayment.balanceModel;
        const mainView = new AutopaymentView({
            renderMode: 'replace',
            el: document.createElement('div'),
            data: {
                sum4payment: balanceModel.get('extra.sum4payment'),
                limit2life: balanceModel.get('extra.limit2life'),
                enabled: this._enabled || balanceModel.get('autopay'),
                stretched: this._stretched,
            },
        });

        mainView.on(AutopaymentView.EVENT_SUBMIT, this._onSubmit);
        mainView.render();
        container.appendChild(mainView.el);

        this._mainView = mainView;
    },

    _onSubmit(event, { enabled, sum4payment, limit2life }) {
        const mainView = this._mainView;

        mainView.lockForm();

        let promise;

        if (enabled) {
            promise = Autopayment.enable({
                sum4payment: parseInt(sum4payment, 10),
                limit2life: parseInt(limit2life, 10),
            });
        } else {
            promise = DialogManager.confirm({
                header: 'Автопополнение',
                message:
                    'Вы действительно хотите отключить автопополнение баланса?',
                ok: 'Отключить',
            }).then(() => {
                return Autopayment.disable();
            });
        }

        promise.then(
            () => {
                mainView.unlockForm();
                ToastNotify.success(
                    'Настройки автопополнения успешно сохранены',
                );

                this.emit('settingsChanged', {});
            },
            () => {
                mainView.unlockForm();
                ToastNotify.error(
                    'Не удалось изменить настройки автопополнения',
                );
            },
        );
    },

    destroy() {
        this.off();

        if (this._mainView) {
            this._mainView.destroy();
            this._mainView = null;
        }

        this.destroyed = true;
    },
});

Object.assign(_Autopayment, {
    setBalanceModel(model) {
        Autopayment.balanceModel = model;
    },

    async enable({ sum4payment, limit2life }) {
        // TODO: move to BalanceModel
        await ApiHelper.rpcCall({
            url: `/api/v1/projects/${BoundCurrentUserSelectors.getPid()}/billing/card/autopay`,
            method: 'POST',
            data: {
                sum4payment: Number(sum4payment).toFixed(2),
                limit2life: Number(limit2life).toFixed(2),
            },
        });

        Autopayment.balanceModel.set(
            {
                autopay: true,
                'extra.sum4payment': sum4payment,
                'extra.limit2life': limit2life,
            },
            {
                silent: true,
            },
        );
    },

    async disable() {
        // TODO: move to BalanceModel
        await ApiHelper.rpcCall({
            url: `/api/v1/projects/${BoundCurrentUserSelectors.getPid()}/billing/card/autopay`,
            method: 'DELETE',
        });

        Autopayment.balanceModel.set(
            {
                autopay: false,
            },
            {
                silent: true,
            },
        );
    },

    showSetupDialog() {
        const dialogView = new AutopaymentDialogView({
            renderMode: 'replace',
            el: $('<div/>').appendTo('.layers'),
        });

        dialogView.show();

        const autopayment = new Autopayment();

        autopayment.on('settingsChanged', () => {
            if (!autopayment.destroyed) {
                autopayment.destroy();
            }

            if (!dialogView.destroyed) {
                dialogView.close();
            }
        });

        const $container = dialogView.getAutopaymentContainer();

        autopayment.renderTo($container[0]);
    },
});

export const Autopayment = _Autopayment;
